import React, { useState } from "react";
import axios from 'axios';
import { KRAKEN_URL } from '../../../../constants'

//Componentes bootstrap
import { Modal } from 'react-bootstrap';
import { Toggles2 } from 'react-bootstrap-icons';
import { toast } from "react-toastify";

function ModalDeshabilitarEmpresaUsuario(props) {    
    const usuario = props.children;
    const [status, setStatus] = useState(false);

    function updateEstatus() {
        setStatus(true);
        axios.post(KRAKEN_URL + 'empresa/servicio/usuarios/updateEstatus',
            {
                "userId": usuario.userId,
                "empresaAlias": usuario.empresaAlias
            }
        ).then((res) => {
            if (res.data.result.code === 200) {
                setStatus(false);
                toast.success(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                props.onUpdate();//Actualiza el listado, llamando a la función padre para actualizarlo  
                props.onHide();//Cierra el modal, llamando a la función padre para cerrarlo 
            } else {
                setStatus(false);
                toast.warning(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                toast.warning(res.data.result.suggestion,{
                    position:"top-center",
                    autoClose: 4500, 
                });
            }
        }).catch((error) => {
            setStatus(false);
            toast.error("Hubo un error, no se pudo actualizar el estatus de este usuario.",{
                position:"top-center",
                autoClose: 4500, 
            });
        })
    }

    return (
        <section className="text-center">
            <Modal
                show={props.show}
                //onHide={props.onHide}
                size="sm"
                id="modalUpdateEstatusUsuario"
                centered
            >
                <Modal.Header className="modal-header-empresa-usuario" closeButton onHide={props.onHide}>
                    <p><Toggles2 size={22} color="#5B4B51" />   Habilitar/Deshabilitar usuario</p>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        &nbsp;¿Está seguro que desea actualizar el estatus de {usuario.username}?
                    </p>
                    <div className="d-flex justify-content-center">
                        <button
                            className="m-1 button-default-confirmar"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Confirmar"
                            onClick={e => updateEstatus()}
                        >{status ?
                            <span>Actualizando...</span>
                            : <span>Confirmar</span>}
                        </button>
                        <button
                            className="m-1 button-default-cancelar"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Cancelar"
                            onClick={props.onHide}
                        ><span>Cancelar</span>
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </section>
    );
}

export default ModalDeshabilitarEmpresaUsuario;